import React from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@lyearn/style';
import { Loader as BaseLoader, Stack, Typography } from '@lyearn/ui';

function Loader({ className }: { className?: string }) {
  const { t } = useTranslation();

  return (
    <Stack
      alignItems="center"
      className={cn(
        'h-40 w-full rounded-8 border border-solid border-interactive-white-hover pe-12 ps-16',
        className,
      )}>
      <BaseLoader arcColorToken="icon-active" circleColorToken="icon-placeholder" size={24} />
      <Typography className="ms-12" color="text-text-placeholder" variant="body-short-02">
        {t('Common:Loading')}
      </Typography>
    </Stack>
  );
}

export default Loader;
